import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor"]

  insert(event) {
    const tag = event.currentTarget.dataset.trixTagValue
    const trixEditor = this.editorTarget.editor

    trixEditor.insertString(tag)
    this.editorTarget.focus()
  }
}
